/** Versioned kickoff ownership: never reinterpret an already booked legacy session. */
export const OWL_GLOBAL_SESSION_FROM = "2026-10-29";
export type OwlWindowPhase = "noon" | "evening";
export function owlGlobalSession(date: string): boolean { return date >= OWL_GLOBAL_SESSION_FROM; }
export function owlWindowBounds(date: string, phase: OwlWindowPhase = "evening") {
  const midnight=Date.parse(`${date}T00:00:00Z`);
  if (!Number.isFinite(midnight) || new Date(midnight).toISOString().slice(0,10)!==date) throw new Error("invalid_owl_session_date");
  return { start:new Date(midnight+(owlGlobalSession(date)?19:phase==="noon"?12:17)*3600_000).toISOString(),
    end:new Date(midnight+(owlGlobalSession(date)?31:27)*3600_000+1000).toISOString() };
}
export function owlSessionAt(now=new Date()): {date:string;phase:OwlWindowPhase} {
  const today=now.toISOString().slice(0,10);
  const previous=new Date(Date.parse(`${today}T00:00:00Z`)-86400_000).toISOString().slice(0,10);
  const end=owlGlobalSession(previous)?Date.parse(owlWindowBounds(previous).end):Date.parse(`${today}T03:00:00Z`);
  const overnight=now.getTime()<end;
  return {date:overnight?previous:today,phase:overnight||now.getUTCHours()>=17?"evening":"noon"};
}
export function owlIsWindowKickoff(kickoff:string,date:string,phase:OwlWindowPhase="evening"):boolean {
  const t=Date.parse(kickoff),bounds=owlWindowBounds(date,phase);
  return Number.isFinite(t)&&t>=Date.parse(bounds.start)&&t<Date.parse(bounds.end);
}
